export type ToastSeverity = "success" | "error" | "info" | "warning";

export interface ToastPayload {
  message: string;
  severity?: ToastSeverity;
}

export const MUI_TOAST_EVENT = "mui-app-toast";

export const showToast = (message: string, severity: ToastSeverity = "info") => {
  if (!message) return;
  window.dispatchEvent(
    new CustomEvent<ToastPayload>(MUI_TOAST_EVENT, {
      detail: { message, severity },
    })
  );
};
